/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PickupOutpostRestaurantNameQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type PickupOutpostRestaurantNameQuery = {
  readonly __typename?: 'Query';
  readonly restaurant: {
    readonly __typename?: 'Restaurant';
    readonly id: string;
    readonly name: string;
  };
};

export const pickupOutpostRestaurantNameQueryMock: ExecutionResult<PickupOutpostRestaurantNameQuery> =
  {
    data: {
      restaurant: {
        id: 'e509e6ea-9fee-442a-9962-587ce7190430',
        name: 'Hello World',
      },
    },
  };

export const PickupOutpostRestaurantNameDocument = gql`
  query PickupOutpostRestaurantName($id: ID!) {
    restaurant(id: $id) {
      id
      name
    }
  }
`;

export function usePickupOutpostRestaurantNameQuery(
  options: Omit<
    Urql.UseQueryArgs<PickupOutpostRestaurantNameQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    PickupOutpostRestaurantNameQuery,
    PickupOutpostRestaurantNameQueryVariables
  >({ query: PickupOutpostRestaurantNameDocument, ...options });
}
